import { useEffect, useState } from 'react';

interface LoadingBlurProps {
  loading: boolean;
  delay?: number;
}

export const useLoadingBlur = ({ loading, delay = 300 }: LoadingBlurProps) => {
  const [blur, setBlur] = useState(loading);

  useEffect(() => {
    let timeout: ReturnType<typeof setTimeout>;

    if (!loading) {
      timeout = setTimeout(() => setBlur(false), delay);
    } else {
      setBlur(true);
    }

    return () => clearTimeout(timeout);
  }, [loading, delay]);

  return { blur };
};
